<template>
  <IconSvgBase :class="$style.icon" :view-width="20" :view-height="20">
    <path
      :class="$style.icon__path"
      d="M12.3334 12.3333C12.3334 12.7916 11.9584 13.1666 11.5001 13.1666C11.0417 13.1666 10.6667 12.7916 10.6667 12.3333V8.99996C10.6667 8.54163 11.0417 8.16663 11.5001 8.16663C11.9584 8.16663 12.3334 8.54163 12.3334 8.99996V12.3333ZM7.33341 2.60663C7.33341 2.47746 7.51175 2.33329 7.75008 2.33329H10.2501C10.4884 2.33329 10.6667 2.47746 10.6667 2.60663V3.99996H7.33341V2.60663ZM7.33341 12.3333C7.33341 12.7916 6.95841 13.1666 6.50008 13.1666C6.04175 13.1666 5.66675 12.7916 5.66675 12.3333V8.99996C5.66675 8.54163 6.04175 8.16663 6.50008 8.16663C6.95841 8.16663 7.33341 8.54163 7.33341 8.99996V12.3333ZM16.5001 3.99996H15.6667H12.3334V2.60663C12.3334 1.53663 11.3992 0.666626 10.2501 0.666626H7.75008C6.60091 0.666626 5.66675 1.53663 5.66675 2.60663V3.99996H2.33341H1.50008C1.04175 3.99996 0.666748 4.37496 0.666748 4.83329C0.666748 5.29163 1.04175 5.66663 1.50008 5.66663H2.33341V14.8333C2.33341 16.2116 3.45508 17.3333 4.83342 17.3333H13.1667C14.5451 17.3333 15.6667 16.2116 15.6667 14.8333V5.66663H16.5001C16.9584 5.66663 17.3334 5.29163 17.3334 4.83329C17.3334 4.37496 16.9584 3.99996 16.5001 3.99996Z"
    />
  </IconSvgBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

export default defineComponent({
  name: 'IconDustBox',
  components: {
    IconSvgBase,
  },
})
</script>

<style lang="scss" module>
.icon {
  $size: 1em;

  width: $size;
  height: $size;

  &__path {
    fill: currentcolor;
  }
}
</style>
